module.exports = "<div class=\"home\">\n  <md-content layout-padding>\n    <div class=\"row\">\n      <div class=\"col-sm-12\" ng-bind-html=\"vm.contents\">\n      </div>\n    </div>\n  </md-content>\n</div>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/views/home/home.html
 ** module id = 38
 ** module chunks = 0
 **/